import React from 'react';
import { getConfig } from '@alfa-bank/newclick-core/utils';
import cn from 'classnames';

import { getLandingImagePath } from '../../../shared/utils';

import styles from './index.module.css';

type Props = {
    className?: string;
};

const QR_CODE_IMAGE_PATH = '/webapp-landing-v2/qr_webapp.png';

export const QrCode = ({ className }: Props) => {
    const { staticBaseUrl, altDomain } = getConfig();
    const qrCodeSrc = getLandingImagePath(QR_CODE_IMAGE_PATH, Boolean(altDomain));

    return (
        <figure
            className={cn(className, styles.container)}
            aria-label='QR-код со ссылкой на веб-приложение'
            data-test-id='qr-code'
        >
            <img className={styles.qrCode} src={`${staticBaseUrl}${qrCodeSrc}`} alt='' />
        </figure>
    );
};
